import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import {Switch, useHistory} from "react-router-dom";

import ListQuotes from "../Pages/listQuotes";
import VerifyQuote from "../Pages/verifyQuote";
import { ApproveQuote } from "../Pages/wizard/ApproveQuote";
import { ClientData } from "../Pages/wizard/ClientData";
import { WorkData } from "../Pages/wizard/WorkData";
import { HealthStatement } from "../Pages/wizard/HealthStatement";
import { Beneficiaries } from "../Pages/wizard/Beneficiaries";
import { AdditionalInfoPart1 } from "../Pages/wizard/AdditionalInfoPart1";
import { AdditionalInfoPart2 } from "../Pages/wizard/AdditionalInfoPart2";
import { VerifySimulation } from "../Pages/wizard/VerifySimulation";
import { thankYouPage } from "../Pages/wizard/thankYouPage";
import { Declaration } from "../Pages/wizard/Declaration";
import ErrorPage from "../Pages/wizard/ErrorPage";
import { OffLine } from "../Pages/wizard/OffLine";

import { ProtectedRoute } from "../Components/privateRoute";
import { DetailPageRV } from "../Pages/wizard/DetailPageRV";
import { ModalitiesPageRV } from "../Pages/wizard/ModalitiesPageRV";

function NestedRoutersQuotations({ path }){
  const elrouter = useHistory()
  const channel = useSelector(
    state => state.login.channel
  );
  const granted = useSelector(
    state => state.login.granted
  );

  const [isInline, setisInline] = useState(true);
  useEffect(() => {
    if (navigator.onLine) {
      setisInline(true);
    }
    window.addEventListener("offline", function () {
      setisInline(false);
    });

    window.addEventListener("online", function () {
      setisInline(true);
    });

    
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    
    updateOnlineStatus();

    return () => window.removeEventListener("online", updateOnlineStatus);
  }, []);

  function updateOnlineStatus() {
    navigator.onLine ? console.log("online") :  elrouter.push('/cotizaciones/sin-conexion');
  }
  return (
    <Switch>
      <ProtectedRoute exact path={path} component={ListQuotes} granted={granted} channel={channel} />
      <ProtectedRoute exact path={path + "/verificacion"} component={VerifyQuote}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/aprobacion"} component={ApproveQuote}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/detalle"} component={DetailPageRV}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/detalle-modalidades"} component={ModalitiesPageRV}  channel={channel} granted={granted}/>

      <ProtectedRoute exact path={path + "/datos-personales"} component={ClientData}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/datos-laborales"} component={WorkData}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/declaracion-de-salud"} component={HealthStatement}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/beneficiarios"} component={Beneficiaries}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/info-complementaria-1"} component={AdditionalInfoPart1}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/info-complementaria-2"} component={AdditionalInfoPart2}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/verificacion-simulacion"} component={VerifySimulation}  channel={channel} granted={granted}/>
      
      <ProtectedRoute exact path={path + "/solicitud-cotizacion"} component={thankYouPage}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/declaracion-jurada"} component={Declaration}  channel={channel} granted={granted}/>
     
      <ProtectedRoute exact path={path + "/error-simulacion"} component={ErrorPage}  channel={channel} granted={granted}/>
      <ProtectedRoute exact path={path + "/sin-conexion"} component={OffLine}  channel={channel} granted={granted}/>
    </Switch>
  );
};

export default NestedRoutersQuotations;

      
